import { Icon } from "@iconify/react";
import { Form, Input, Modal, Select, Space } from "antd";

// eslint-disable-next-line react/prop-types
export default function RegistrationModalFilter ({ form, responsiveFilter,  setResponsiveFilter,  setKeyword, keyword, districts = [], villages = [], cities = [], district, city }){



  return (
    <Modal
      open={responsiveFilter}
      centered
      title="Filter"
      onCancel={() => setResponsiveFilter(false)}
      onOk={() => setResponsiveFilter(false)}
    >
      <Form form={form} >
        <Space size={'large'} direction="vertical" style={{ width: '100%', margin: '20px 0' }}  >
          <Input 
            prefix={<Icon icon="hugeicons:search-01" width="16" height="16" />}
            placeholder="cari.."
            onChange={e => setKeyword(e.target.value)}
            value={keyword}
            allowClear
          />
          <Form.Item noStyle  name={'city'} >
            <Select
              allowClear
              style={{ width: '100%' }}
              options={cities?.map(e => ({ label: e.name, value: e.name }))}
              placeholder="Kota"
            />
          </Form.Item>
          <Form.Item noStyle  name={'district'} >
            <Select
              allowClear
              style={{ width: '100%' }}
              options={districts?.map(e => ({ label: e.name, value: e.name }))}
              placeholder="Kecamatan"
              disabled={!city}
            />
          </Form.Item>
          <Form.Item noStyle name={'village'}  >
            <Select
              allowClear
              style={{ width: '100%' }}
              options={villages?.map(e => ({ label: e.name, value: e.name }))}
              placeholder="Kelurahan"
              disabled={!district}
            />
          </Form.Item>
        </Space>
      </Form>
    </Modal>
  )
}